<template>
    <div class="background">
        <div
            class="text">
            休息一会
        </div>
        <div
            v-on:click="login"
            class="login-area"
        >
            <a-icon
                class="login-icon"
                type="login" />
            <div class="login-text">
                继续
            </div>
        </div>
        <div
            v-on:click="logout"
            class="logout-area">
            <a-icon
                class="logout-icon"
                type="logout" />
            <div class="logout-text">
                退出
            </div>
        </div>
    </div>
</template>

<script>
 import EventBus from "../event/event-bus.js"

 export default {
     name: 'RestPage',
     props: {
     },
     components: {
     },
     methods: {
         logout() {
             this.$router.replace("/")
             this.$store.commit("updateRestMoment", false)
         },
         login() {
             EventBus.$emit("restBack")
         }
     }
 }
</script>

<style scoped>
 .background {
     width: 100%;
     height: 100%;
     background-color: rgba(0, 0, 0, 0.8);

     position: fixed;
     top: 0;
     bottom: 0;
     left: 0;
     right: 0;

     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
 }

 .text {
     color: #FFF;
     font-size: 70px;
 }

 .loading-text {
     color: #FFF;
     font-size: 20px;
     margin-top: 20px;
 }

 .logout-area {
     position: fixed;
     top: 20px;
     right: 30px;

     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;

     color: #AAA;
     cursor: pointer;
     transition: all .2s ease-in;
 }

 .logout-area:hover {
     color: #FFF;
 }

 .logout-icon {
     font-size: 30px;
 }

 .logout-text {
     font-size: 14px;
     margin-top: 5px;
 }

 .login-area {
     color: #AAA;
     margin-top: 20px;
 }

 .login-area:hover {
     color: #FFF;
 }

 .login-icon {
     font-size: 50px;
 }

 .login-text {
     font-size: 24px;
     margin-top: 5px;
 }
</style>
